<template>
    <app-layout>
        <template #header>
            <Breadcrumb :items="[
      {
          label : 'Home',
          link : '/',
      },
      {
          label : 'Entrevistas',
          link : route('entrevista.index'),
      },
      {
          label : 'Visualizar',
          link :  route('entrevista.show' , entrevista.id),
      }
      ]"></Breadcrumb>
        </template>
        <div class="max-w-screen-xl mx-auto py-2 sm:px-2 lg:px-6">

            <div class="md:grid space-y-4">
                <div
                    v-if="entrevista.codigo_acesso"
                    class="col-span-2"
                >
                    <div class="py-4 bg-yellow-300 text-xl text-center">
                        <span>Código de acesso : </span> {{ entrevista.codigo_acesso }}
                    </div>
                </div>
                <div class="mt-2 mt-sm-5 md:mt-0 md:col-span-2">
                    <div class="py-2">
                        <span class="text-gray-600">Dados cadastrais</span>
                    </div>
                    <div class="shadow overflow-hidden sm:rounded-md">
                        <div class="px-6 py-5 bg-white">
                            <div class="grid grid-cols-12 gap-6 py-2">
                                <div class="col-span-12 md:col-span-1  ">
                                    <label class="block font-medium text-gray-700 mb-2">
                    <span>
                      Status
                    </span>
                                    </label>
                                    <StateBadge :state="entrevista.state_obj"></StateBadge>
                                </div>
                                <div class="col-span-12 md:col-span-5 ">
                                    <label class="block font-medium text-gray-700 mb-2">
                    <span>
                      Funcionário
                    </span>
                                    </label>
                                    {{ entrevista.funcionario_id | VMask("#### ######") }} - {{ entrevista.nome }}
                                </div>
                                <div class="col-span-12 md:col-span-6  ">
                                    <label class="block font-medium text-gray-700 mb-2">
                    <span>
                      Unidade
                    </span>
                                    </label>
                                    {{ entrevista.centro_custo && entrevista.centro_custo.nome }}
                                </div>
                                <div class="col-span-12 md:col-span-4  ">
                                    <label class="block font-medium text-gray-700 mb-2">
                    <span>
                      Função
                    </span>
                                    </label>
                                    {{ entrevista.funcao_nome }}
                                </div>
                                <div class="col-span-12 md:col-span-1  ">
                                    <label class="block font-medium text-gray-700 mb-2">
                    <span>
                      Sexo
                    </span>
                                    </label>
                                    {{ entrevista.sexo }}
                                </div>
                                <div class="col-span-12 md:col-span-1  ">
                                    <label class="block font-medium text-gray-700 mb-2">
                    <span>
                      Idade
                    </span>
                                    </label>
                                    {{ entrevista.idade }} anos
                                </div>
                                <div class="col-span-12 md:col-span-3 ">
                                    <label class="block font-medium text-gray-700 mb-2">
                    <span>
                      Escolaridade
                    </span>
                                    </label>
                                    {{ entrevista.escolaridade_nome }}
                                </div>
                                <div class="col-span-12 md:col-span-3 ">
                                    <label class="block font-medium text-gray-700 mb-2">
                    <span>
                      Seguimento étnico e racial
                    </span>
                                    </label>
                                    {{ entrevista.seguimento_etnico }}
                                </div>
                                <div class="col-span-12 md:col-span-4  ">
                                    <label class="block font-medium text-gray-700 mb-2">
                                        <span>CAT: Central atendimento</span>
                                    </label>
                                </div>
                                <div class="col-span-12 md:col-span-4  ">
                                    <label class="block font-medium text-gray-700 mb-2">
                    <span>
                      Lider imediato
                    </span>
                                    </label>
                                    {{ entrevista.superior_imediato }}
                                </div>
                                <div class="col-span-12 md:col-span-2  ">
                                    <label class="block font-medium text-gray-700 mb-2">
                    <span>
                      Tempo de empresa
                    </span>
                                    </label>
                                    {{ entrevista.tempo_empresa_humans }}
                                </div>
                            </div>

                            <div
                                v-if="entrevista.colaborador_recusou"
                                class="border rounded my-4"
                            >
                                <div class="p-2 bg-yellow-300  rounded text-center text-xl">
                                    Colaborador recusou-se a preencher o formulário da Entrevista de Desligamento.
                                </div>
                                <div class="py-4 px-2 ">
                                    Motivo: {{ entrevista.colaborador_recusou_motivo }}
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
                <div class="mt-2 mt-sm-5 md:mt-0 md:col-span-2">
                    <div class="py-2">
                        <span class="text-gray-600">Motivo de desligamento</span>
                    </div>
                    <div class="shadow overflow-hidden sm:rounded-md">
                        <div class="px-6 py-5 bg-white">
                            <div class="grid grid-cols-12 gap-6 py-2">
                                <div class="col-span-12 md:col-span-6  ">
                                    <label class="block font-medium text-gray-700 mb-2">
                    <span>
                      Desligamento solicitado {{ motivoDesligamentoLabel }}
                    </span>
                                    </label>
                                </div>
                                <div class="col-span-12    ">
                                    <label class="block font-medium text-gray-700 mb-2">
                    <span>
                      {{ motivoDesligamentoJoin }}
                    </span>
                                    </label>
                                </div>

                            </div>

                        </div>
                    </div>

                </div>

                <div class="col-span-2 flex  justify-end space-x-8">
                    <div
                        v-if="permissions.podeRecusar"
                        class="mr-auto"
                        v-loading="isLoading"
                    >

                        <div
                            @click="showMotivoRecusa= true"
                            class="cursor-pointer bg-white hover:bg-gray-200 text-black py-2 px-4 rounded inline-flex items-center shadow "
                        >
                            <i class="fas fa-exclamation-triangle text-yellow-300 text-xl px-2"></i>
                            <div>
                <span class="text-red-600">
                  Clique aqui se o colaborador recusou-se a preencher a Entrevista de Desligamento.</span>
                            </div>
                        </div>

                    </div>
                    <div
                        v-if="permissions.podeVisualizarRespostas && entrevista.state_obj.id !== 'PENDENTE'"
                        class="flex space-x-2"
                    >
                        <div>
                            <a
                                :href="route('entrevista-questionario-visualizar', entrevista.id)"
                                target="_blank"
                                class="bg-white hover:bg-gray-200 text-black py-2 px-4 rounded inline-flex items-center shadow"
                            >
                                <i class="fa fa-folder-open pr-2"></i>
                                <div> Visualizar respostas</div>
                            </a>
                        </div>
                        <div>
                            <a
                                :href="urlDownload"
                                target="_blank"
                                class="bg-white hover:bg-gray-200 text-black py-2 px-4 rounded inline-flex items-center shadow space-x-2"
                            >
                                <IconPdf class="h-4"></IconPdf>
                                <div>Download respostas</div>
                            </a>
                        </div>
                    </div>

                </div>

                <div
                    v-if="permissions.podeDeletar"
                    class="pt-12  col-span-2"
                >
                    <DestroyZone
                        :identificador="entrevista.id"
                        :rota="route('entrevista.destroy', entrevista.id)"
                        label="Excluir entrevista"
                    ></DestroyZone>
                </div>
            </div>
        </div>

        <JetDialogModal
            :show='showMotivoRecusa'
            max-width="4xl"
        >
            <template #title>
                <div class="text-2xl text-center bg-yellow-300 p-4">O candidato recusou-se a responder</div>
            </template>
            <template #content>
                <div class="p-4">
                    <div class="text-left">

                        <div class="text-gray-600">
                            <span class="font-bold mb-2">Motivo:</span>
                            <el-input
                                type="textarea"
                                :rows="6"
                                v-model="form.colaborador_recusou_motivo"
                            ></el-input>
                            <jet-input-error
                                :message="form.errors.colaborador_recusou_motivo"
                                class="mt-2"
                            />
                        </div>
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="flex justify-end space-x-4">
                    <button
                        class="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded"
                        @click="()=>{
                form.clearErrors();
                form.reset();
                showMotivoRecusa = false;
            }"
                    >
                        Cancelar
                    </button>
                    <button
                        class="bg-yellow-400 hover:bg-yellow-500 text-gray-800 font-bold py-2 px-4 rounded"
                        @click="handleRecusa"
                    >
                        Salvar
                    </button>
                </div>
            </template>
        </JetDialogModal>

    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout';
import Breadcrumb from '@/Components/Breadcrumb';
import JetActionMessage from '@/Jetstream/ActionMessage';
import JetDialogModal from '@/Jetstream/DialogModal';
import JetInputError from '@/Jetstream/InputError';
import ButtonPrimary from '@/Components/ButtonPrimary';
import ButtonSecondary from '@/Components/ButtonSecondary';
import SelectAutocomplete from '@/Components/SelectAutocomplete.vue';
import CheckGroup from '@/Components/CheckGroup.vue';
import StateBadge from '@/Components/StateBadge.vue';
import IconPdf from '@/Components/Icons/Pdf.vue';
import DestroyZone from '@/Components/DestroyZone.vue';


export default {
    props: {
        entrevista: Object,
        urlDownload: String,
        permissions: Object
    },
    components: {
        AppLayout,
        Breadcrumb,
        JetActionMessage,
        ButtonPrimary,
        ButtonSecondary,
        JetInputError,
        SelectAutocomplete,
        CheckGroup,
        StateBadge,
        IconPdf,
        DestroyZone,
        JetDialogModal,
    },
    data() {
        return {
            form: this.$inertia.form({
                colaborador_recusou_motivo: ''
            }),
            showMotivoRecusa: false,
            isLoading: false,
        }
    },
    computed: {
        motivoDesligamentoLabel() {
            return this.entrevista.demissao_solicitada_por === 'EMPRESA' ? 'pela empresa' : 'pelo funcionário';
        },
        motivoDesligamentoJoin() {
            return _.join(_.map(this.entrevista.motivo_desligamento, 'nome'), ', ');
        }
    },
    methods: {
        handleRecusa() {
            this.form.put(this.route('entrevista-recusa', this.entrevista.id), {
                preserveScroll: true,
                onSuccess: () => {
                    this.showMotivoRecusa = false;
                    this.isLoading = false;
                }
            })
        }
    }

}
</script>

<style>
</style>
